import React, { Dispatch, SetStateAction, useState } from "react";
import styled from "styled-components";
import ConfirmBtn from "../../../Button/ConfirmBtn";
import LineBtn from "../../../Button/LineBtn";
import FilterIcon from "../../../DefaultStyles/FilterIcon";
import Flex from "../../../DefaultStyles/Flex";
import DropDown, { OptionType } from "../../../Filters/DropDown";
import Search from "../../../Filters/Search";
import { useRecoilValue } from "recoil";
import { partyInviteTabState } from "./PartyInviteTab";
import { macroStateOptionList } from "../PartyDetail/MacroStateChangeModal/macrostate";

interface PartyInviteFilterProps {
  setSearchValue: Dispatch<SetStateAction<string | undefined>>;
  filteringValue: {
    regState: number;
    macro: number;
  };
  setFilteringValue: any;
  setPage: Dispatch<SetStateAction<number>>;
}

export default function PartyInviteFilter({
  setSearchValue,
  filteringValue,
  setFilteringValue,
  setPage,
}: PartyInviteFilterProps) {
  const tab = useRecoilValue(partyInviteTabState);

  const [dropDownValue, setDropDownValue] = useState<OptionType>({
    value: "2",
    label: "등록 전",
  });
  const [macroDropdown, setMacroDropdown] = useState<OptionType>({
    value: "",
    label: "매크로 상태 선택",
  });

  const regStateOption = [
    { value: "0", label: "24시간 이상 경과" },
    { value: "2", label: "등록 전" },
    { value: "3", label: "등록 완료" },
    { value: "1", label: "전체" },
  ];

  const secondaryRegStateOption = [
    { value: "0", label: "24시간 이상 경과" },
    { value: "2", label: "등록 전" },
    {
      value: "4",
      label: "초대 수락 필요",
    },
    { value: "3", label: "등록 완료" },
    { value: "1", label: "전체" },
  ];

  return (
    <LinkidMailFilterContainer>
      <Search
        placeholder="PID 입력"
        setSearchValue={setSearchValue}
        isDisabled={false}
        pageResetEvent={() => setPage(0)}
        inputType="number"
      />

      <Flex gapSize={10}>
        <FilterIcon maxWidth={900} />

        <DropDown
          isDisabled={false}
          initText="등록 여부"
          dropdownValue={dropDownValue}
          setDropDownValue={setDropDownValue}
          optionList={tab === 2 ? secondaryRegStateOption : regStateOption}
          boxWidth={150}
        />

        <DropDown
          isDisabled={false}
          dropdownValue={macroDropdown}
          setDropDownValue={setMacroDropdown}
          optionList={macroStateOptionList(true)}
        />

        <ConfirmBtn
          btnText="적용"
          btnColor="mint"
          btnHeight={38}
          btnClickEvent={() => {
            setPage(0);
            setFilteringValue({
              ...filteringValue,
              regState: dropDownValue?.value ? +dropDownValue?.value : 0,
              macro: macroDropdown?.value ? +macroDropdown?.value : 0,
            });
          }}
          isDisabled={dropDownValue?.value === ""}
        />

        <LineBtn
          btnText="초기화"
          icon="refresh"
          btnHeight={38}
          btnColor="mint"
          disabled={dropDownValue?.value === ""}
          btnClickEvent={() => {
            setDropDownValue({
              value: "2",
              label: "등록 전",
            });

            setMacroDropdown({
              value: "",
              label: "매크로 상태 선택",
            });

            setFilteringValue({
              ...filteringValue,
              regState: 2,
              macro: 0,
            });
          }}
        />
      </Flex>
    </LinkidMailFilterContainer>
  );
}

const LinkidMailFilterContainer = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  margin-bottom: 12px;

  @media screen and (max-width: 900px) {
    flex-direction: column;
    align-items: flex-start;
  }
`;
